"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CricketBall = function CricketBall(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M11.1607407,33.3597864 C10.569311,32.9683128 9.99826152,32.533298 9.45210537,32.054737 L32.054737,9.45210537 C32.533298,9.99826152 32.9683128,10.569311 33.3597864,11.1607407 L11.1607407,33.3597864 Z M13.0854961,34.4487157 L34.4487157,13.0854961 C37.2832873,19.0297307 36.2327665,26.369869 31.3013177,31.3013177 C26.369869,36.2327665 19.0297307,37.2832873 13.0854961,34.4487157 Z M7.94526301,30.5478946 C7.46670198,30.0017385 7.03168715,29.430689 6.64021358,28.8392593 L28.8392593,6.64021358 C29.430689,7.03168715 30.0017385,7.46670198 30.5478946,7.94526301 L7.94526108,30.5478966 Z M5.55128429,26.9145039 C2.71671268,20.9702693 3.76723351,13.630131 8.69868227,8.69868227 C13.630131,3.76723351 20.9702693,2.71671268 26.9145039,5.55128429 L5.55128429,26.9145039 Z"
      });
    }
  }));
};
CricketBall.defaultProps = {
  color: null
};
var _default = exports["default"] = CricketBall;
var name = exports.name = 'CricketBall';
var availableProps = exports.availableProps = ['color'];